export enum PublicPagesModes {
  View = 'view',
  Add = 'add',
}
